import { Component, OnInit } from '@angular/core';
import { serviceURLService } from '../service/serviceURL';
import { DataService } from '../data.service';

@Component({
  selector: 'app-new-notifications',
  templateUrl: './new-notifications.component.html',
  styleUrls: ['./new-notifications.component.css']
})
export class NewNotificationsComponent implements OnInit {

  notifications: any[] = [];
  selectedNotification: any = null;
  loading = false;
  userId: string = '';
  filterType: string = 'all';
  filteredNotifications: any[] = [];

  constructor(
    private serviceURLService: serviceURLService,
    private dataService: DataService
  ) {
    this.userId = localStorage.getItem('userID') || '';
  }

  ngOnInit(): void {
    this.getNotifications();
  }

  selectNotification(notification: any): void {

    this.selectedNotification = notification;

    if (!notification.isRead) {
      notification.isRead = true;

      this.serviceURLService
        .markNotificationAsRead(notification._id)
        .subscribe({
          next: () => {
             this.applyFilter();
            this.updateUnreadCount()
          },
          error: (err) => console.error(err)
        });
    }
  }

  goBack(): void {
    this.selectedNotification = null;
  }

  getNotifications(): void {

  if (this.loading) return;

  this.loading = true;

  this.serviceURLService.getNotifications(this.userId).subscribe({
    next: (response: any) => {

      this.notifications = response?.notifications?.notifications || [];

      this.applyFilter();

      this.loading = false;
    },
    error: (error) => {
      console.error('Error fetching notifications:', error);
      this.loading = false;
    }
  });

}

  updateUnreadCount() {
    this.serviceURLService
      .getCountOfNotifications(this.userId)
      .subscribe((res: any) => {
        this.dataService.notificationsCount.next(
          res?.unreadCount?.unreadCount || 0
        );
      });
  }

  trackById(index: number, item: any) {
    return item?._id;
  }

  setFilter(type: string) {
  this.filterType = type;
  this.applyFilter();
}

applyFilter() {

  if (this.filterType === 'unread') {

    this.filteredNotifications = this.notifications.filter(
      n => !n.isRead
    );

  } else {

    this.filteredNotifications = [...this.notifications];

  }

}
}